import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AppConfig } from './app.config';
import { AuthService } from './auth.service';
import { CryptoExtension } from '../utils/crypto.extension';
import { Injectable } from '@angular/core';
import { DataUtilsCore } from 'channn-lib';
@Injectable({
    providedIn: 'root'
})
export class BaseService {
    public API_DATA_DEFINE = `${AppConfig.config.apis.apiUrl}/api/data/process`;
    public API_URl = `${AppConfig.config.apis.apiUrl}`;
    public APPVERSION = `${AppConfig.config.appVersion}`;
    errorMsg: string;
    constructor(
        private http: HttpClient,
        private _authService: AuthService,
        private _router: Router) {

    }
    public post_Data(url: string, data: any): Observable<any> {
        return this.http.post<any>(`${this.API_URl}${url}`, data, { headers: this.getHeaders() })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    private getHeaders(token?: string): HttpHeaders {
        let headers = new HttpHeaders().set('content-type', 'application/json');
        headers = headers.set('Authorization', `Bearer ${token || this._authService.getAuthToken()}`);
        return headers;
    }
    public getDataAPI_Promise(code: string, data: any) {
        return this.getDataAPI(code, data).toPromise().then(data => [null, data])
            .catch(err => [err]);
    }
    public getDataAPIDefault_Promise(code: string, data: any) {
        return this.getDataAPIDefault(code, data).toPromise().then(data => [null, data])
            .catch(err => [err]);
    }
    public Upload_Promise(data: any) {
        let formData = new FormData();
        formData.append("tbname", data.tbname);
        formData.append("Resize_Width", "400");
        formData.append("Resize_Height", "400");
        for (const file of Object.keys(data.files)) {
            formData.append(data.colname, data.files[file]);
        }
        if(data.postion && data.postion != ''){
            formData.append("postion", data.postion);
        }
        return this.getFormAPIDefault("/api/data/process/uploadfiles", formData).toPromise().then(data => [null, data])
            .catch(err => [err]);
    }
    public getFormAPI(code: string, data: any, formdata: FormData, username?: string) {
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', `Bearer ${this._authService.getAuthToken()}`);
        var res = CryptoExtension.encryptHMAC(code, data, username);
        formdata.append("token", '' + res["token"]);
        formdata.append("reqtime", res["reqtime"]);
        Object.keys(data).forEach(function (key) {
            formdata.append(key, data[key]);
        })
        var url = this.API_URl +'/api/data/process/'+ code;
        return this.http.post<any>(url, formdata, { headers })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    public getDataAPI(code: string, data: any, url?: string, username?: string, token?: string, appversion?: string): Observable<any> {
        const headers = this.getHeaders(token);
        if (!username) {
            username = this._authService.getUsername();
        }
        if (!appversion) {
            appversion = this.APPVERSION;
        }
        let urctlnk = this._router.url;
        data.urctlnk = urctlnk;
        let res = CryptoExtension.encryptHMAC(code, data, username);
        let _data = {
            "token": '' + res["token"],
            "reqtime": res["reqtime"],
            "data": data,
            "appversion": appversion
        };
        let requestUrl = url ? `${url}/${code}` : `${this.API_DATA_DEFINE}/${code}`;
        return this.http.post<any>(requestUrl, _data, { headers })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    public getDataAPI_Url(url: string, code: string, data: any, username: string, token: string): Observable<any> {
        const headers = this.getHeaders(token);
        let urctlnk = this._router.url;
        data.urctlnk = urctlnk;
        let res = CryptoExtension.encryptHMAC(code, data, username);
        let _data = {
            "token": '' + res["token"],
            "reqtime": res["reqtime"],
            "data": data
        };
        return this.http.post<any>(`${url}/${code}`, _data, { headers })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    public getDataAPI_Chat(code: string, data: any): Observable<any> {
        const headers = this.getHeaders();
        let urctlnk = this._router.url;
        data.urctlnk = urctlnk;
        let res = CryptoExtension.encryptHMAC(code, data, this._authService.getUsername());
        let _data = {
            "token": '' + res["token"],
            "reqtime": res["reqtime"],
            "data": data,
            "appversion": this.APPVERSION
        };
        return this.http.post<any>(`${this.API_URl}${code}`, _data, { headers })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    public downloadFile(url) {
        return window.open(
            `${this.API_URl}${url}`,
            '_blank' // <- This is what makes it open in a new window.
        );
    }
    public getFormAPIDefault(url: string, data: any): Observable<any> {
        let headers = new HttpHeaders()
        headers = headers.set('Authorization', "Bearer " + this._authService.getAuthToken());
        return this.http.post<any>(`${this.API_URl}${url}`, data, { headers })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    public GetDataPagingFull(pageNumber: number, pageLen: number, tbname: string, filter: any, sortField: string, sortOrder: number, moreExp: string, isAction: string, isNoConfig: number, cols: string) {
        let headers = new HttpHeaders()
        headers = headers.set('Authorization', "Bearer " + this._authService.getAuthToken());
        const data_Send = {
            tbname: tbname,
            pageNumber: pageNumber,
            pageLen: pageLen,
            filter: CryptoExtension.encode(JSON.stringify(filter)),
            sortField: CryptoExtension.encode(sortField),
            moreExp: CryptoExtension.encode(moreExp),
            sortOrder: sortOrder,
            isAction: isAction,
            isNoConfig: isNoConfig,
            cols: CryptoExtension.encode(cols),
        }
        return this.http.post<any>(`${this.API_URl}/api/data/GetDataPaging`, data_Send, { headers })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    public GetDataPaging(pageNumber: number, pageLen: number, tbname: string, filter: any, sortField: string, sortOrder: number, moreExp: string, isAction: string) {
        return this.GetDataPagingFull(pageNumber, pageLen, tbname, filter, sortField, sortOrder, moreExp, isAction, 0, "")
    }
    public GetDataSelect(colID: string, page: string, keys: string, oldValue: string, isFilter: string, formValue: any): Observable<any> {
        let _formValue: any = {};
        for (const key of Object.keys(formValue)) {
            if (typeof (formValue[key]) == 'object') {
                if (formValue[key] != null) {
                    if (formValue[key]["id"]) {
                        _formValue[key] = formValue[key]["id"];
                    } else if (formValue[key]["v"]) {
                        _formValue[key] = formValue[key]["v"];
                    } else if (Array.isArray(formValue[key])){
                        let dataMultipleValue = formValue[key].map(t => {
                            return t.hasOwnProperty('id') ? t.id : (t.hasOwnProperty('ID') ? t.ID : ''); 
                        });
                        _formValue[key] = dataMultipleValue.toString();
                    } else if (formValue[key] instanceof Date){
                        _formValue[key] = DataUtilsCore.formatDateTime(formValue[key], 'YYYY-MM-DD');
                    }
                } else {
                    _formValue[key] = -100;
                }
            } else {
                _formValue[key] = formValue[key];
            }
        }
        let headers = new HttpHeaders()
        headers = headers.set('Authorization', "Bearer " + this._authService.getAuthToken());
        var formData: any = new FormData();
        formData.append('colID', CryptoExtension.encode(colID));
        formData.append('page', page);
        formData.append('keys', CryptoExtension.encode(keys));
        formData.append('oldValue', oldValue);
        formData.append('isFilter', isFilter);
        formData.append('dataRow', CryptoExtension.encode(JSON.stringify(_formValue)));
        return this.http.post<any>(`${this.API_URl}/api/data/select`, formData, { headers })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    public getDataAPIDefault(code: string, data: any): Observable<any> {
        const headers = this.getHeaders();
        let urctlnk = this._router.url;
        data.urctlnk = urctlnk;
        return this.http.post<any>(`${this.API_URl}${code}`, data, { headers })
            .pipe(
                map((response: any) => response),
                catchError(error => this.handleError(error))
            );
    }
    private handleError(error: HttpErrorResponse): Observable<never> {
        let errorMsg: string;
        if (error.error instanceof ErrorEvent) {
            errorMsg = `Error: ${error.error.message}`;
        } else {
            errorMsg = this.getServerErrorMessage(error);
        }
        return throwError(errorMsg);
    }
    private getServerErrorMessage(error: HttpErrorResponse): string {
        if (error.status == 400) {
            if (error.error.message) {
                return `${error.error.message}`;
            }
            if (error.error.errordata) {
                let errorMessages = this.extractErrorMessages(error.error.errordata);
                return [...new Set(errorMessages)].join(', ');
            }
        }
        switch (error.status) {
            case 401: {
                this._router.navigateByUrl("/auth/login");
                break;
                return `Not Found: ${error.message}`;
            }
            case 404: {
                return `Not Found: ${error.message}`;
            }
            case 403: {
                return `Access Denied: ${error.message}`;
            }
            case 500: {
                return `Internal Server Error: ${error.message}`;
            }
            default: {
                return `Unknown Server Error: ${error.message}`;
            }

        }
    }
    /**
     * Tuong.TT 2024-10-22
     * Extract error messages
     * @param errors 
     * @returns 
     */
    private extractErrorMessages(errors: any[]): string[] {
        let messages: string[] = [];

        errors.forEach((error) => {
            if (error.ErrorData && error.ErrorData.length > 0) {
                // If ErrorData exists, recurse into it
                messages = messages.concat(this.extractErrorMessages(error.ErrorData));
            } else if (error.ErrorTextVN) {
                // Collect ErrorTextVN if available
                messages.push(error.ErrorTextVN);
            }
        });

        return messages;
    }
}